import {ScaleContentLikeImage} from './scale-content-like-image';

const SELECTOR = 'ui-illustration__component';

export class UiIllustrations {
  constructor() {
    this.illustrations = [];
    document.querySelectorAll(`.${SELECTOR}`).forEach(this.addIllustration.bind(this));
  }

  addIllustration($elem) {
    this.illustrations.push($elem);
    this._initTextScale($elem);
    $elem.classList.add(`${SELECTOR}--initialized`);
  }

  _initTextScale(elem) {
    return new ScaleContentLikeImage(elem);
  }
}
